import { ComponentProps } from 'react';
import { Card } from '../card/card';

type CheckoutCardProps = ComponentProps<typeof Card>;

export const CheckoutCard = ({ ...props }: CheckoutCardProps) => {
  return <Card as="fieldset" css={{ height: 'fit-content' }} {...props} />;
};
